import { skipToken } from '@tanstack/react-query';
import { useMemo } from 'react';
import { SpcTogglesMap } from '../../../shared/types/spc.ts';
import { defaultSpcToggles } from '../../../shared/utils/defaultSpcToggles.ts';
import { ProtocolFinal } from '../../types/sharedTypeImpl.ts';
import { trpc, trpcClient } from '../../utils/trpc/trpc.ts';


interface Props {
    protocol: ProtocolFinal | undefined,
}

export function useSpcToggles({
    protocol,
}: Props) {

    const { data: loadedSpcToggles, refetch } = trpc.spc.getToggles.useQuery(
        protocol ? { protocolId: protocol._id! } : skipToken,
        { refetchOnWindowFocus: false, }
    );

    const defaultSpcTogglesMap = useMemo(() => {
        if (!protocol) return;
        return Object.fromEntries(
            protocol.positions.map(({ positionNumber }) => [positionNumber, defaultSpcToggles()])
        ) as SpcTogglesMap;
    }, [protocol]);

    const spcTogglesMap = loadedSpcToggles ?? defaultSpcTogglesMap;


    const handleSpcTogglesChange = async (isEnabled: boolean, colIdx: number, positionNumber?: string) => {
        if (!protocol) return;

        await trpcClient.spc.setToggles.mutate({
            protocolId: protocol._id!,
            positionNumber,
            checkIdx: colIdx,
            isEnabled,
        });
        refetch();
    }

    return { spcTogglesMap, handleSpcTogglesChange };
}
